<div [ngStyle]="{'width': '90%'}" ngStyle.lt-lg="{'width': '100%'}" >

  <div style="margin-top:28px; font-size: 14px; font-weight: 500;">

    <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
  </div>
  <form [formGroup]="formReceipts" style="margin-top: 15px;">


    <div style="margin-top:15px; margin-bottom:-5px;">
      <div fxLayout="row" fxLayout.lt-md="column wrap">
        <div fxFlex="25">
          <mat-form-field appearance="outline" style="width:150px;">
            <mat-label>Permit Cost </mat-label>
            <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="1" required id="permitCostPreReceipt" name="permitCostPreReceipt"
              formControlName="permitCost" />
              @if (formReceipts.get('permitCost')?.hasError('required')) {
                <mat-error>
                  Permit Cost is required.
                </mat-error>
              }
              @if (formReceipts.get('permitCost')?.hasError('min')) {
                <mat-error>
                  Permit  Cost must be greater than $1.00.
                </mat-error>
              }
              <mat-hint>
                $1 or more
              </mat-hint>
            </mat-form-field>
          </div>

          <div fxFlex="25">
            <mat-form-field appearance="outline" style="width:150px;">
              <mat-label>Engineered Plan Cost</mat-label>
              <input matInput (change)="setCostToZeroIfEmpty($event)" currencyMask min="1" id="engineeredPlanCost" name="engineeredPlanCost"
                formControlName="engineeredPlanCost" />
                @if (formReceipts.get('engineeredPlanCost')?.hasError('min')) {
                  <mat-error>
                    Engineered Plan Cost must be greater than $1.00.
                  </mat-error>
                }
                <mat-hint>
                  $1 or more
                </mat-hint>
              </mat-form-field>
            </div>
            <div fxFlex="25">

            </div>
            <div fxFlex="25">
            </div>
          </div>
        </div>



        <div style="margin-top: 12px; ">

          <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
        </div>

        <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap.lt-md="3px" >

          <div fxFlex="25" style="margin-top: 15px; ">
            <label for="totalamount"><strong>TOTAL COSTS</strong></label>
          </div>


          <div fxFlex="25" style="margin-top: 15px; ">
            <div  style="width:150px;height:30px;text-align:right"><strong>{{ totalAmount() | currency  }}</strong></div>

          </div>
          <div fxFlex="25"></div>
          <div fxFlex="25"></div>
        </div>

        <div style="margin-bottom: 12px; ">
          <mat-divider [ngStyle]="{'width': '100%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
        </div>
        <div>
          <button mat-raised-button color="primary" type="submit" (click)="onClickSaveReceiptsInfo()"
            [disabled]="disableSaveButton && (formReceipts.pristine || formReceipts.invalid)">
            SAVE & SUBMIT
          </button>
        </div>
        @if (autoSaveIndicator) {
          <div style="margin-top: 12px;">
            <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
          </div>
        }
      </form>
    </div>